import appLogger from '@shared/logging/appLogger';
import { createClient } from 'contentful';
import { v4 as uuidv4 } from 'uuid';

type ContentOptions = {
    includeDepth?: number;
    queryParams?: { key: string; value: string }[];
};

export default async function getContentEntriesByType<T>(
    contentType: string,
    options?: ContentOptions
) {
    const urlWithoutProtocolOrTrailingSlash = process.env.AUCTIONS_GATEWAY_BASEURL.replace(
        /(^\w+:|^)\/\//,
        ''
    ).replace(/\/$/, '');

    const client = createClient({
        accessToken: '123', // This is a fake access token as it is a required param but supplied by the gateway
        space: 'qeontfmijmzv',
        environment: 'master',
        host: urlWithoutProtocolOrTrailingSlash,
        basePath: 'contentful',
        headers: {
            'X-Correlation-ID': uuidv4(),
        },
    });

    const query = {
        content_type: contentType,
        include: options?.includeDepth ?? 2,
    };

    if (options.queryParams?.length > 0) {
        options.queryParams.forEach(kvp => {
            query[kvp.key] = kvp.value;
        });
    }

    try {
        const response = await client.getEntries(query);

        return response;
    } catch (err) {
        const errorObject = JSON.parse(err.message);
        if (
            errorObject?.status &&
            errorObject.status >= 400 &&
            errorObject.status < 500 &&
            errorObject.status !== 404
        ) {
            const error = new Error(
                `Error getting content for type ${contentType}: ${errorObject.status} `
            );
            appLogger.logException({
                error: error,
                properties: { requestUrl: errorObject.request?.url },
            });
            throw err;
        }
        return null;
    }
}
